import { validate } from "validate.js";

validate.validators.imagesize = function(value, options, key, attributes) {
  if(!value){
    return;
  }
  let padding, inBytes, base64StringLength;
  if (value.endsWith("==")) {
    padding = 2;
  } else if (value.endsWith("=")) {
    padding = 1;
  } else {
    padding = 0;
  }
  base64StringLength = value.length;
  inBytes = (base64StringLength / 4) * 3 - padding;
  let sizeInKb = inBytes / 1000;
  if (sizeInKb > 3000) {
    return "^errors.new_circle.image_to_big";
  }
};

// url: {
  //   url: {
  //     message: "^errors.new_circle.valid_url"
  //   }
  // },

const validators = {
  name: {
    length: {
      minimum: 2,
      message: "^errors.new_circle.product_name"
    }
  },
  description: {
    length: {
      minimum: 2,
      message: "^errors.new_circle.description"
    }
  },
  price: {
    numericality: {
      greaterThan: 0,
      message: "^errors.new_circle.add_product_price"
    }
  },
  address: {
    length: {
      minimum: 5,
      message: "^errors.new_circle.add_location"
    }
  },
  base64_image: {
    imagesize: {
      message: "^errors.new_circle.image_to_big"
    }
  }
};

export default validators;
